export function getUserTimezone (): string {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timeZone) {
      console.error('getUserTimezone: resolved timezone is empty, falling back to UTC');
      return 'UTC';
    }
    return timeZone;
  } catch (error) {
    console.error('getUserTimezone: failed to resolve timezone, falling back to UTC', error);
    return 'UTC';
  }
}
